import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthLayoutComponent } from './layout/auth-layout/auth-layout.component';
import { ContentLayoutComponent } from './layout/content-layout/content-layout.component';
import { FooterComponent } from './layout/footer/footer.component';
import { NavComponent } from './layout/nav/nav.component';
import { SideBarComponent } from './layout/side-bar/side-bar.component';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from './core/core.module';
import { AuthModule } from './modules/auth/auth.module';
import { SharedModule } from './shared/shared.module';
import { ApiUriFactory, API_URI } from './API_URI';

import { ToastrModule } from 'ngx-toastr';
import { CollapseModule} from "ngx-bootstrap/collapse";
import { BsDatepickerModule,DatepickerModule } from "ngx-bootstrap/datepicker";
import { PaginationModule } from "ngx-bootstrap/pagination";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { TypeaheadModule } from "ngx-bootstrap/typeahead";
import { PopoverModule } from 'ngx-bootstrap/popover';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

import { TranslateLoader, TranslateModule} from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { TokenInterceptor } from './core/interceptor/token.interceptor';
import { ErrorInterceptor } from './core/interceptor/error.interceptor';
import { NotFoundComponent } from './page-not-found';
import { LoaderService } from './shared/service/loader.service';
import { LoaderComponent } from './shared/components/loader/loader.component';
import { LoaderInterceptor } from './core/interceptor/loader.interceptor';

import { DataTablesModule } from 'angular-datatables';

import {CalendarModule} from 'primeng/calendar';
import { DatePipe } from '@angular/common';
import { AuthGuard } from './core/guard/auth.guard';
import { NoAuthGuard } from './core/guard/no-auth.guard';
import { UserRoleGuard } from './core/guard/user-role.guard';

@NgModule({
  declarations: [
    AppComponent,   
    LoaderComponent,

    AuthLayoutComponent,
    ContentLayoutComponent,
    
    FooterComponent,
    NavComponent,
    SideBarComponent,
    NotFoundComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    
    FormsModule, 
    ReactiveFormsModule,
    HttpClientModule,

    //angular-datatable
    DataTablesModule.forRoot(),

    AuthModule,    

    SharedModule,
    CoreModule,

    //ngx-bootstrap
    CollapseModule.forRoot(),
    ToastrModule.forRoot(),
    BsDatepickerModule.forRoot(),
    DatepickerModule.forRoot(),
    TimepickerModule.forRoot(),
    PaginationModule.forRoot(),
    TooltipModule.forRoot(),
    PopoverModule.forRoot(),
    TypeaheadModule.forRoot(),
    BsDropdownModule.forRoot(),

    NgxSpinnerModule,

    // PrimeNg
    CalendarModule,

    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpTranslateLoader,
        deps: [HttpClient]
      }
    }),
    
    AppRoutingModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    // { provide: APP_INITIALIZER, useFactory: appInitializer, multi: true, deps: [AuthService] },
    LoaderService,NgxSpinnerService,DatePipe, 
    AuthGuard, NoAuthGuard,  UserRoleGuard,
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    { provide: API_URI, useFactory: ApiUriFactory },
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true }],
  bootstrap: [AppComponent]
})
export class AppModule { }

// AOT compilation support
export function httpTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
